<template lang="pug">
  section.CollectionView(v-if="data")
    .CollectionView_background
      PageTransitionLayer

    .CollectionView_wrapper(v-if="!isTransitioning")
      CollectionCover(:title="data.title", :type="data.collectionType", :numOfDrawers="data.numOfDrawers", :backgroundImg="data.derivatives")

      section.PageContent_section.PageContent-with-relief
        ParagraphList(:items="data.paragraphs", v-if="data.paragraphs").PageContent
        ParagraphKeyFigures(:item="data.keyFigures", v-if="data.keyFigures")
      CollectionDrawerList(:uuid="data.id", :title="data.title")

      ScrollTop

</template>

<script>

import CollectionModel from '@/models/CollectionModel'
import CollectionCover from '@/components/CollectionCover'
import ParagraphKeyFigures from '@/components/paragraphs/ParagraphKeyFigures'
import CollectionDrawerList from '@/components/CollectionDrawerList'
import customTransitionMixins from '../mixins/customTransitionMixins'
import {TweenLite} from 'gsap'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import ParagraphList from '@/components/ParagraphList'
import ScrollTop from '@/components/common/ScrollTop'
import i18n from '@/i18n'

export default {
  mixins: [customTransitionMixins],
  name: 'collection-view',
  props: ['uuid'],
  components: {
    CollectionCover,
    ParagraphKeyFigures,
    CollectionDrawerList,
    PageTransitionLayer,
    ParagraphList,
    ScrollTop
  },
  data () {
    return {
      data: null,
      meta: null,
      isTransitioning: false
    }
  },
  created () {
    this.fetchData()
    this.fetchMeta()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.$api.getCollection(this.$i18n.locale, this.uuid)
        .then(response => {
          this.data = new CollectionModel(response.data.data, response.data.included)
        })
    },
    fetchMeta () {
      this.$api.getPageMetaTag(this.$i18n.locale, this.uuid)
        .then(response => {
          this.meta = this.$metatag.formateMeta(response.data)
        })
    },
    /**
     * Override la méthode transitionIn de customTransitionMixins
     * Afin de définir une animation custom
     */
    transitionIn (next) {
      this.isTransitioning = true

      const timeline = new TimelineLite({onComplete: () => {
        // On défini qu'on est plus en transition
        this.isTransitioning = false

        next()
      }})

      // Juste un delai
      // permettant de voir le composant PageTransitionLayer s'animer
      timeline.delay(1.2)
    }
  }
}
</script>

<style lang="stylus" scoped>

.CollectionView

  &_background
    position: fixed
    top 0
    right 0
    bottom 0
    left 0
    width 100vw
    height 100vh

  &_wrapper
    position relative

</style>
